export default "__VITE_ASSET__d9c35c08__"